import { render, staticRenderFns } from "./servicosEditar.vue?vue&type=template&id=2cebe20e&scoped=true&"
import script from "./servicosEditar.vue?vue&type=script&lang=js&"
export * from "./servicosEditar.vue?vue&type=script&lang=js&"
import style0 from "./servicosEditar.vue?vue&type=style&index=0&id=2cebe20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cebe20e",
  null
  
)

export default component.exports